export default __webpack_public_path__ + "static/chrisFrame-75040024733173afd48b7355558d978e.png";